import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiClientConnector from 'src/api/ApiClientConnector';

// Async thunk for sending chat messages
export const sendChatMessage = createAsyncThunk(
  'chat/sendMessage',
  async ({ instance, accounts, message }, { rejectWithValue }) => {
    try {
      const client = await ApiClientConnector(instance, accounts);
      const response = await client.chat.sendMessage(message);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to send message');
    }
  }
);

const initialState = {
  messages: [],
  sessionId: null,
  isLoading: false,
  error: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addUserMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    clearChat: (state) => {
      state.messages = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendChatMessage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendChatMessage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.messages.push({
          role: 'assistant',
          content: action.payload.Message,
          timestamp: action.payload.Metadata?.lastUpdated || new Date().toISOString(),
          metadata: action.payload.Metadata,
          id: Math.random().toString(36).substr(2, 9)
        });
      })
      .addCase(sendChatMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { addUserMessage, setSessionId, clearChat, clearError } = chatSlice.actions;
export default chatSlice.reducer;
